// src/apiConfig.js
// const API_BASE_URL = "http://192.168.1.195:80/name"; // Dev IP
const API_BASE_URL = "https://reod.myprisma.in"; // Live IP

export default API_BASE_URL;
